<template>
  <div class="page-testimonials">

    <div v-for="(block, index) in blocks" :key="`1${index}`">
      <info-block :data="block"></info-block>
    </div>

    <div class="container is-gap-top color-lightgreen-bg"
      v-for="(test, index) in testimonials" :key="`2${index}`"
      data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <div class="is-gap-large">
            <div>
              <b>{{ test && test.title }}</b>
              <b v-if="test && test.subtitle && test.subtitle.length > 0">
                {{ ` - ${test && test.subtitle}` }}
              </b>
            </div>
            <div class="is-gap-top">
              {{ test && test.content }}
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import _ from 'lodash'
// import Util from '@/util'
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/site'

import InfoBlock from '@/pages/base/infoblock'

export default {
  name: 'page-testimonials',
  props: {
    // msg: String
  },
  components: {
    InfoBlock,
  },
  data () {
    return {
      loading: false,
      isDesktop: true,
      blocks: [],
      testimonials: [],
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    async refresh () {
      try {
        this.$set(this, 'loading', true)
        let promises = []
        let promise
        promise = this.getBlocks()
        promises.push(promise)
        promise = this.getTestimonials()
        promises.push(promise)
        await Promise.all(promises)
        this.$set(this, 'loading', false)
      } catch (error) {
        this.$set(this, 'loading', false)
        this.$message({
          message: `Refresh failed: ${error.message || error}`,
          type: 'error'
        })
      }
    },

    async getBlocks () {
      this.$set(this, 'blocks', [])
      let data = await Site.infoNamedLike('page-testimonials')
      this.$set(this, 'blocks', data)
    },

    async getTestimonials () {
      this.$set(this, 'testimonials', [])
      let data = await Site.testimonials()
      this.$set(this, 'testimonials', data)
    },
  }
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

.page-testimonials {
  .rounded-wrapper {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    background-color: lightgray;
    background-repeat: no-repeat;
    background-color: #dedede;
    background-position: 50% 50%;
    background-size: auto 100%;
  }
}

</style>
